export type Severity = 'error' | 'warning';

export type ConstraintKind
  = | 'enum'
    | 'reference'
    | 'shape'
    | 'range'
    | 'unique'
    | 'graph'
    | 'custom';

export interface Constraint {
  kind: ConstraintKind;
  allowedValues?: string[];
  expectedType?: string;
  detail?: string;
}

export interface Locator {
  nodeId?: string;
  characterId?: string;
  branchId?: string;
}

export type FixKind = 'replace' | 'remove' | 'insert';

export interface Fix {
  kind: FixKind;
  value?: unknown;
  rationale: string;
}

export interface ValidationIssue {
  code: string;
  severity: Severity;
  message: string;
  path: (string | number)[];
  pointer: string;
  locator?: Locator;
  currentValue?: unknown;
  constraint: Constraint;
  fix?: Fix;
}

/** A locator holding only the parts that are strings, so an absent branch stays absent. */
export const locatorOf = (parts: { [K in keyof Locator]?: unknown }): Locator =>
  Object.fromEntries(Object.entries(parts).filter(([, value]) => typeof value === 'string')) as Locator;

export const toPointer = (path: (string | number)[]): string => {
  if (path.length === 0) {
    return '';
  }
  return `/${path.map(seg => String(seg).replace(/~/g, '~0').replace(/\//g, '~1')).join('/')}`;
};
